// ─── src/api/communityCatalysts.ts ───────────────────────────────────────────

import { apiClient } from "./registration";
import type {
  CommunityCatalystParams,
  CommunityCatalystRegistration,
  CommunityCatalystResponse,
  CommunityCatalystStats,
} from "../types/communityCatalyst";
import type { PaginationMeta } from "../types/registration";

const BASE = "/Registration_Community_Catalysts";

export interface NormalisedCommunityCatalystResponse {
  data: CommunityCatalystRegistration[];
  meta: PaginationMeta;
}

const normalise = (
  raw: CommunityCatalystResponse,
): NormalisedCommunityCatalystResponse => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getCommunityCatalysts = async (
  params: CommunityCatalystParams,
): Promise<NormalisedCommunityCatalystResponse> => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<CommunityCatalystResponse>(BASE, {
    params: cleanParams,
  });
  return normalise(data);
};

export const getCommunityCatalystStats = async (): Promise<CommunityCatalystStats> => {
  const { data } = await apiClient.get<CommunityCatalystStats>(`${BASE}/stats`);
  return data;
};

export const deleteCommunityCatalyst = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

/** Admin-only: seed or reset a catalyst's dashboard login password. */
export const setCatalystPassword = async (email: string, password: string): Promise<void> => {
  await apiClient.post("/catalyst-portal/password", { email, password });
};
